import { coins } from '../mockedData'

export const INITIAL_FIELDS = {
  amount: 0,
  destinationWallet: '',
  coin: 'USDC',
  network: 'POLYGON',
  destinationNetwork: 'POLYGON',
}

const NETWORK_COINS = {
  TRON: ['USDT', 'TRX'],
  POLYGON: ['USDC', 'POL', 'USDT'],
  // ETHEREUM: ['ETH', 'USDC', 'USDT'],
  // SOLANA: ['SOL', 'USDC'],
}

export const getCoinsByNetwork = (network) => {
  const allowedCoins = NETWORK_COINS[network]

  if (!allowedCoins) {
    return coins
  }

  return coins.filter((coin) => allowedCoins.includes(coin.value))
}

export const getCrossNetworkCoins = () => {
  return coins.filter((coin) => coin.value === 'USDT')
}